import Papa from 'papaparse';

export function downloadCSV(csvContent: string, filename = 'export.csv') {
  const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' });
  const link = document.createElement('a');
  const url = URL.createObjectURL(blob);

  link.setAttribute('href', url);
  link.setAttribute('download', filename);
  link.style.visibility = 'hidden';
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
  setTimeout(() => { URL.revokeObjectURL(url); }, 100);
}

export function exportToCSV<TData>(
  data: TData[],
  transformRow: (item: TData) => Record<string, unknown>
): string {
  const rows = data.map(transformRow);

  const csv: string = Papa.unparse(rows, {
    quotes: true,
    header: true,
  });
  return csv;
}
